import React from "react";
import ServicePageTemplate from "@/components/common/ServicePageTemplate";

export default function TradingServices() {
  return (
    <ServicePageTemplate
      seo={{
        title: "International Trading Services | Premier Global Sourcing",
        description: "Coordinate commercial requirements between buyers and sellers across international markets with an international trade team.",
        path: "/trading-services",
      }}
      breadcrumbs={[{ label: "Trading Services" }]}
      eyebrow="Trading Services"
      title="Coordinate commercial trade between markets"
      intro="Coordinate commercial requirements between buyers and sellers in different markets, keeping every conversation organized and clear."
      leadCopy="International trading involves aligning commercial terms, product details and expectations across parties in different markets. We help keep that coordination structured."
      image="https://images.unsplash.com/photo-1670121180530-cfcba4438038?crop=entropy&cs=srgb&fm=jpg&q=85&w=1100"
      imageAlt="International container terminal representing cross-border trade"
      bullets={[
        "Coordination between buyers and sellers across markets",
        "Organized commercial and product information",
        "Clear next steps at each stage of the discussion",
        "Connection to sourcing and logistics coordination",
      ]}
      subServices={[
        { icon: "ArrowLeftRight", title: "Buyer–Seller Coordination", copy: "Coordinate commercial requirements between parties in different markets." },
        { icon: "FileText", title: "Commercial Documentation Support", copy: "Help keep commercial information and trade documentation organized." },
        { icon: "Handshake", title: "Requirement Alignment", copy: "Align product details, quantities and expectations before commitments." },
      ]}
      note="We coordinate commercial requirements and information. Regulated activities such as customs or freight may be arranged through qualified partners where applicable."
    />
  );
}
